import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Collapse, MenuItem, Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import SysRecord from "app/class/record";
import Translate from "component/global/translation/translation-component";
import HomeMenuItem from "./home-menu-item";

interface HomeMenuItemCollapsableProps {
    currentMenuRecord: SysRecord;
    menuRecordList: SysRecord[];
    onClose: () => void;
    isOpen: boolean;
    onToggle: (isOpen: boolean) => void;
}

const HomeMenuItemCollapsable = ({
    currentMenuRecord,
    menuRecordList,
    onClose,
    isOpen,
    onToggle,
}: HomeMenuItemCollapsableProps) => {
    const toggleMenu = (event: React.MouseEvent) => {
        event.stopPropagation();
        onToggle(!isOpen);
    };

    return (
        <>
            <MenuItem
                onClick={toggleMenu}
                disableRipple
                sx={{
                    mx: 0.75,
                    my: 0.25,
                    minHeight: 40,
                    borderRadius: 2,
                    gap: 1,
                    color: "primary.main",
                    "&:hover": {
                        backgroundColor: "action.hover",
                    },
                }}
            >
                <Translate text={currentMenuRecord.label} variant="body2" sx={{ flex: 1, fontWeight: 700 }} />
                {isOpen ? (
                    <ExpandLess sx={{ color: "primary.main", fontSize: 20 }} />
                ) : (
                    <ExpandMore sx={{ color: "primary.main", fontSize: 20 }} />
                )}
            </MenuItem>

            <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <Box
                    sx={{
                        ml: 1.75,
                        pl: 1,
                        borderLeft: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.22)}`,
                    }}
                >
                    {menuRecordList.map((menuRecord) => {
                        return (
                            <HomeMenuItem
                                key={`submenu-${currentMenuRecord.id}-${menuRecord.id}`}
                                currentMenuRecord={menuRecord}
                                handleClose={onClose}
                                isSubItem
                            />
                        );
                    })}
                </Box>
            </Collapse>
        </>
    );
};

export default HomeMenuItemCollapsable;
